// frontend/src/Pages/LandingPage.jsx
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";

export default function LandingPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    const userRole = localStorage.getItem("userRole");
    if (userRole) {
      if (userRole === "admin") navigate("/dashboard");
      else if (userRole === "manager") navigate("/production");
      else if (userRole === "driver") navigate("/delivery");
      else if (userRole === "user") navigate("/production");
    }
  }, [navigate]);

  const userRole = localStorage.getItem("userRole");
  const username = localStorage.getItem("username");

  const features = [
    { icon: "🚚", title: "Delivery Management", desc: "Plan routes, assign drivers, track deliveries in real time" },
    { icon: "🍞", title: "Production Tracking", desc: "Record daily baking, monitor stock levels automatically" },
    { icon: "👥", title: "Client Ledger", desc: "Full payment history and balance for every client" },
    { icon: "💼", title: "Accounting", desc: "Income, expenses and monthly profit reports" },
    { icon: "👨‍💼", title: "HR & Advances", desc: "Manage staff, partners and advance payments" },
    { icon: "📊", title: "Reports & Exports", desc: "PDF and Excel exports for your accountant" },
  ];

  return (
    <div style={{ fontFamily: "'Segoe UI', sans-serif", background: "#F5E9D8", minHeight: "100vh" }}>

      {/* 
      ── NAVBAR (DISABLED) ── 
      <nav style={{
        background: "#2D2F5E",
        padding: "0 2rem",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        height: "64px",
        position: "sticky",
        top: 0,
        zIndex: 100,
        boxShadow: "0 4px 12px rgba(45,47,94,0.3)"
      }}>
        <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
          <span style={{ fontSize: "1.6rem" }}>🍞</span>
          <span style={{ color: "#F5E9D8", fontWeight: 800, fontSize: "1.15rem", letterSpacing: "0.5px" }}>
            Pyszna Food
          </span>
          <span style={{
            background: "#F76B4C",
            color: "white",
            fontSize: "0.6rem",
            fontWeight: 700,
            padding: "3px 8px",
            borderRadius: "20px",
            letterSpacing: "1.2px",
            marginLeft: "2px"
          }}>ERP</span>
        </div>
      </nav>
      */}

      {/* ── HERO ── */}
      <div style={{
        background: "linear-gradient(135deg, #2D2F5E 0%, #1a1c3e 60%, #2D2F5E 100%)",
        padding: "6rem 2rem 5rem",
        textAlign: "center",
        position: "relative",
        overflow: "hidden",
      }}>
        {/* Background decoration */}
        <div style={{
          position: "absolute", top: "-80px", right: "-80px",
          width: "300px", height: "300px",
          borderRadius: "50%",
          background: "rgba(247,107,76,0.08)",
          pointerEvents: "none"
        }} />
        <div style={{
          position: "absolute", bottom: "-60px", left: "-60px",
          width: "200px", height: "200px",
          borderRadius: "50%",
          background: "rgba(245,233,216,0.05)",
          pointerEvents: "none"
        }} />

        {/* Welcome for logged-in partners */}
        {userRole === "partner" && (
          <div style={{ color: "#F5E9D8" }}>
            <div style={{ fontSize: "3rem", marginBottom: "1rem" }}>👋</div>
            <h1 style={{ fontSize: "2.2rem", fontWeight: 800, marginBottom: "0.5rem", letterSpacing: "-0.5px" }}>
              Welcome back, {username}!
            </h1>
            <p style={{ opacity: 0.7, fontSize: "1.05rem" }}>You are logged in as a Partner.</p>
          </div>
        )}

        {/* Public hero */}
        {!userRole && (
          <>
            <div style={{ fontSize: "3.5rem", marginBottom: "1.2rem" }}>🍞</div>
            <h1 style={{
              color: "#F5E9D8",
              fontSize: "clamp(1.9rem, 4vw, 3.2rem)",
              fontWeight: 900,
              marginBottom: "1.2rem",
              lineHeight: 1.15,
              maxWidth: "750px",
              margin: "0 auto 1.2rem",
              letterSpacing: "-0.5px"
            }}>
              {t("welcome") || "Smart ERP for Bakery Business"}
            </h1>
            <p style={{
              color: "#F76B4C",
              fontSize: "1.15rem",
              fontWeight: 600,
              marginBottom: "0.8rem",
              letterSpacing: "0.2px"
            }}>
              {t("builtBy") || "Built for Pyszna Food Bakery, Bangladeshi Entrepreneurs in Poland"}
            </p>
            <p style={{
              color: "rgba(245,233,216,0.8)",
              fontSize: "1rem",
              maxWidth: "550px",
              margin: "0 auto 0.8rem",
              lineHeight: 1.7
            }}>
              {t("tagline") || "Manage deliveries, production, clients and finances — all in one place"}
            </p>
            <p style={{
              color: "rgba(245,233,216,0.5)",
              fontSize: "0.9rem",
              fontStyle: "italic",
              marginBottom: "0"
            }}>
              {t("slogan") || "From oven to invoice — we've got you covered"}
            </p>
          </>
        )}
      </div>

      {/* ── STATS BAR ── */}
      {!userRole && (
        <div style={{
          background: "#2D2F5E",
          padding: "1.5rem 2rem",
          display: "flex",
          justifyContent: "center",
          gap: "3.5rem",
          flexWrap: "wrap",
          borderTop: "1px solid rgba(245,233,216,0.1)",
          borderBottom: "1px solid rgba(245,233,216,0.1)"
        }}>
          {[
            { value: "5+", label: "User Roles" },
            { value: "100%", label: "Cloud Based" },
            { value: "24/7", label: "Always Online" },
            { value: "🔒", label: "SSL Secured" },
          ].map((stat, i) => (
            <div key={i} style={{ textAlign: "center" }}>
              <div style={{ color: "#F76B4C", fontWeight: 800, fontSize: "1.4rem", letterSpacing: "-0.5px" }}>{stat.value}</div>
              <div style={{ color: "rgba(245,233,216,0.6)", fontSize: "0.75rem", marginTop: "4px", textTransform: "uppercase", letterSpacing: "1px" }}>{stat.label}</div>
            </div>
          ))}
        </div>
      )}

      {/* ── FEATURES GRID ── */}
      {!userRole && (
        <div style={{ padding: "5rem 2rem", maxWidth: "1100px", margin: "0 auto" }}>
          <h2 style={{
            textAlign: "center",
            color: "#2D2F5E",
            fontWeight: 800,
            fontSize: "1.8rem",
            marginBottom: "0.5rem",
            letterSpacing: "-0.3px"
          }}>
            Everything Your Bakery Needs
          </h2>
          <p style={{
            textAlign: "center",
            color: "#2D2F5E",
            opacity: 0.6,
            marginBottom: "3.5rem",
            fontSize: "1rem"
          }}>
            One system. All your operations. Zero confusion.
          </p>

          <div style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
            gap: "1.8rem"
          }}>
            {features.map((f, i) => (
              <div key={i} style={{
                background: "white",
                borderRadius: "16px",
                padding: "2rem",
                boxShadow: "0 4px 20px rgba(45,47,94,0.06)",
                border: "1px solid rgba(45,47,94,0.06)",
                transition: "transform 0.25s ease, box-shadow 0.25s ease",
                cursor: "default"
              }}
                onMouseOver={e => {
                  e.currentTarget.style.transform = "translateY(-6px)";
                  e.currentTarget.style.boxShadow = "0 12px 32px rgba(45,47,94,0.12)";
                }}
                onMouseOut={e => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow = "0 4px 20px rgba(45,47,94,0.06)";
                }}
              >
                <div style={{ fontSize: "2.4rem", marginBottom: "1rem" }}>{f.icon}</div>
                <h3 style={{ color: "#2D2F5E", fontWeight: 700, fontSize: "1.1rem", marginBottom: "0.5rem", letterSpacing: "-0.2px" }}>
                  {f.title}
                </h3>
                <p style={{ color: "#2D2F5E", opacity: 0.65, fontSize: "0.9rem", lineHeight: 1.65, margin: 0 }}>
                  {f.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* ── WHO IS IT FOR ── */}
      {!userRole && (
        <div style={{
          background: "#2D2F5E",
          padding: "4.5rem 2rem",
          textAlign: "center"
        }}>
          <h2 style={{ color: "#F5E9D8", fontWeight: 800, fontSize: "1.7rem", marginBottom: "0.5rem", letterSpacing: "-0.3px" }}>
            Designed For Your Team
          </h2>
          <p style={{ color: "rgba(245,233,216,0.6)", fontSize: "0.95rem", marginBottom: "3rem" }}>
            Each role sees only what they need
          </p>
          <div style={{
            display: "flex",
            justifyContent: "center",
            gap: "1.5rem",
            flexWrap: "wrap",
            maxWidth: "850px",
            margin: "0 auto"
          }}>
            {[
              { role: "Admin", icon: "👑", desc: "Full access" },
              { role: "Manager", icon: "📋", desc: "Operations" },
              { role: "Driver", icon: "🚗", desc: "Deliveries" },
              { role: "Production", icon: "👨‍🍳", desc: "Baking records" },
            ].map((r, i) => (
              <div key={i} style={{
                background: "rgba(245,233,216,0.06)",
                border: "1px solid rgba(245,233,216,0.12)",
                borderRadius: "16px",
                padding: "1.5rem 2rem",
                minWidth: "130px",
                transition: "transform 0.25s ease, background 0.25s ease",
                cursor: "default"
              }}
                onMouseOver={e => {
                  e.currentTarget.style.transform = "translateY(-4px)";
                  e.currentTarget.style.background = "rgba(245,233,216,0.1)";
                }}
                onMouseOut={e => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.background = "rgba(245,233,216,0.06)";
                }}
              >
                <div style={{ fontSize: "2rem", marginBottom: "0.6rem" }}>{r.icon}</div>
                <div style={{ color: "#F5E9D8", fontWeight: 700, fontSize: "1rem", letterSpacing: "0.2px" }}>{r.role}</div>
                <div style={{ color: "rgba(245,233,216,0.5)", fontSize: "0.8rem", marginTop: "4px" }}>{r.desc}</div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* ── FOOTER ── */}
      <footer style={{
        background: "#1a1c3e",
        padding: "2.5rem 2rem",
        textAlign: "center",
      }}>
        <div style={{ color: "rgba(245,233,216,0.5)", fontSize: "0.85rem", marginBottom: "0.6rem", fontWeight: 500 }}>
          🫓 Pyszna Food Bakery ERP — Built with ❤️ for Bakery Businesses
        </div>
        <div style={{ color: "rgba(245,233,216,0.3)", fontSize: "0.75rem", letterSpacing: "0.5px" }}>
          Version 2.0.0 · 2026 · All rights reserved
        </div>
      </footer>

    </div>
  );
}